import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/certifire/Certifire_Slider.webp';
import projectImage2 from '../../../../assets/images/work/certifire/Certifire_Slider_2.webp';
import projectImage3 from '../../../../assets/images/work/certifire/Certifire_Slider_3.webp';
import projectImage4 from '../../../../assets/images/work/certifire/Certifire_Slider_4.webp';
import projectImage5 from '../../../../assets/images/work/certifire/Certifire_Slider_5.webp';
import projectImage6 from '../../../../assets/images/work/certifire/Certifire_Slider_6.webp';
import projectImage7 from '../../../../assets/images/work/certifire/Certifire_Slider_7.webp';


import Data_CertiFire from './Data_CertiFire';

function Work_CertiFire() {
    const canonical = 'https://studio.norcat.org/OurWork/certifire';
    const title = 'CertiFire | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, CertiFire is a VR training experience that helps fire alarm technicians practise inspection, troubleshooting, and decision-making in realistic scenarios before working in the field.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the CertiFire VR training project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the CertiFire VR training project"
            />
            <DetailedHeader
                heading="Redefining Fire Alarm Technician Training"
                client="ECAO, Certi-Fire"
                service="Virtual Reality"
                date="2023-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=biZxcipVRFI"
                images={[
                    {
                        image: projectImage1,
                        alt: 'CertiFire project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'CertiFire project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'CertiFire project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'CertiFire project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'CertiFire project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'CertiFire project screenshot 6',
                    },
                    {
                        image: projectImage7,
                        alt: 'CertiFire project screenshot 7',
                    },
                ]}
            />

            {Data_CertiFire.content}
        </>
    );
}

export default Work_CertiFire;
